import React, { useContext, useMemo } from 'react';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import {
  SortableListContext,
  SortableSubListContext,
} from './context/sortable-context';
import SortableCard from './components/Card/SortableCard';
const SortableSubList = () => {
  const { listData, accessor, handleSortedData } =
    useContext(SortableListContext);
  const { list, depth } = useContext(SortableSubListContext);
  const children = useMemo(() => {
    const childrenData = list[accessor[depth]]?.map((l: any) => l) || [];
    return childrenData;
  }, [accessor, depth, list]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = children.findIndex((item: any) => item.id === active.id);
      const newIndex = children.findIndex((item: any) => item.id === over.id);
      const finalSection = arrayMove(children, oldIndex, newIndex);
      list[accessor[depth]] = finalSection;
      handleSortedData(listData);
    }
  };
  return (
    <DndContext
      sensors={sensors}
      onDragEnd={handleDragEnd}
      collisionDetection={closestCenter}
    >
      <SortableContext
        items={children.map((list: any) => list.id)}
        strategy={verticalListSortingStrategy}
      >
        {React.Children.toArray(
          children.map((list: any) => (
            <SortableCard list={list} depth={depth + 1} />
          ))
        )}
      </SortableContext>
    </DndContext>
  );
};

export default SortableSubList;
